import React from 'react';
import Logo from '../../assets/img/logo/134x54_text_orange.png';
import { useTranslation } from 'react-i18next';

function Header({title}) {
    const { t } = useTranslation();

    function logoClickHandler(){
        window.location.href = "/";
    }

    return (
        <>
            <div className='header'>
                <div id="pageTitle">
                    {t(title)}
                    <span className="textHighlight">
                        Digest Page
                    </span>
                </div>
                <div id="pageLogoImage">
                    <img src={Logo} alt="#" onClick={logoClickHandler} style={{cursor: 'pointer'}}/>
                </div>
            </div>
        </>
    )
}

export default Header;